import { ApolloLink, Operation, FetchResult, Observable } from 'apollo-link';
import { print } from 'graphql';
import { Client } from 'graphql-ws';

// Because we're on Apollo Client v2, we will need to manually implement the GraphQLWsLink.
// See recipe: https://the-guild.dev/graphql/ws/recipes#client-usage-with-apollo-client-web
export class GraphQLWsLink extends ApolloLink {
  constructor(private client: Client) {
    super();
  }

  public request(operation: Operation): Observable<FetchResult> {
    return new Observable(sink => {
      return this.client.subscribe<FetchResult>(
        { ...operation, query: print(operation.query) },
        {
          next: (result: FetchResult) => {
            // Because we're on Apollo Client v2, null values returned from the server
            // are not handled gracefully by this version of InMemoryCache. Without this
            // transformation, attempting to normalize the null data to store it in the cache
            // will throw an error and the websocket connection will be closed prematurely.
            // Our version of Apollo also prevents us from providing a `errorPolicy` value
            // to the useSubscription hook to handle these errors manually, which was
            // introduced in Apollo Client v3.
            // Confluence is also on Apollo Client v2 and they handled this same issue using
            // a similar approach.
            const transformedResult: FetchResult = {
              ...result,
              data: result.data === null ? {} : result.data,
            };
            sink.next(transformedResult);
          },
          complete: sink.complete.bind(sink),
          error: sink.error.bind(sink),
        }
      );
    });
  }
}
